import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";
import { alpha } from "@mui/material/styles";
import { lightBlue } from "@mui/material/colors";

export const useStyles = makeStyles<Theme>((theme) => ({
  title: {
    marginBottom: 8,
  },
  description: {
    marginBottom: 24,
  },

  infoAlert: {
    alignItems: 'center',
    backgroundColor:
      theme.palette.mode === "dark"
        ? lightBlue[900]
        : lightBlue[50],
    '& .MuiAlert-icon': {
      color:
        theme.palette.mode === "dark"
          ? lightBlue[50]
          : lightBlue[900],
    },
    '@media (max-width: 767px)': {
      display: 'flex',
      flexDirection: 'column',
    },
  },

  info: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: "space-between",
    gap: 12,
    '& > p': {
      color:
        theme.palette.mode === "dark"
          ? lightBlue[50]
          : lightBlue[900],
    },
    '& > button': {
      color:
        theme.palette.mode === "dark"
          ? lightBlue[50]
          : lightBlue[900],
    },
    '@media (max-width: 767px)': {
      flexDirection: 'column',
      textAlign: 'center',
    },
  },

  list: {
    borderWidth: 1,
    borderColor: theme.palette.divider,
    borderStyle: 'solid',
    borderRadius: 4,
    width: '100%',
    marginTop: 16,
    maxHeight: 282,
    overflow: 'hidden',
  },
  listItem: {
    minHeight: 38,
    padding: '7px 8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottomWidth: 1,
    borderColor: theme.palette.divider,
    borderStyle: 'solid',
    minWidth: 'fit-content',
    '&:last-child': {
      borderBottom: 'none!important',
    }
  },
  listItemId: {
    wordBreak: 'break-word',
  },
  listItemStatus: {
    color: theme.palette.text.secondary,
  },

  actions: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: 16,
    marginTop: 24,
    '@media (max-width: 767px)': {
      flexDirection: "column",
    },
    '& button': {
      width: "100%",
    }
  },

  customScroll: {
    margin: '0 0 0 0',
    width: 'auto!important',
    '& .view': {
      margin: '0 -12px 0 0',
      paddingRight: '0',
    },
    '& .track-vertical': {
      top: 5,
      right: 4,
      bottom: 4,
      borderRadius: '3px',
      width: '4px!important',
      backgroundColor: alpha(theme.palette.action.selected, theme.palette.action.selectedOpacity),
      '& > div': {
        position: 'relative',
        display: 'block',
        width: '100%',
        cursor: 'pointer',
        borderRadius: 'inherit',
        backgroundColor: `${alpha(theme.palette.secondary.light, 0.3)}!important`,
      }
    },
    '& .track-horizontal': {
      bottom: 2,
      left: 8,
      right: 8,
      height: '4px!important',
      borderRadius: '3px',
      backgroundColor: alpha(theme.palette.action.selected, theme.palette.action.selectedOpacity),
      '& > div': {
        position: 'relative',
        display: 'block',
        cursor: 'pointer',
        borderRadius: '3px!important',
        backgroundColor: `${alpha(theme.palette.secondary.light, 0.3)}!important`,
      }
    },
  },
}));
